<template>
  <div v-cloak>
    <tabs v-model="activeName">
      <pane name="1" :label="this.$t('enterprise.orgDetail')">
        <orgInfoDeatil :parentDept="parentDept" :currentOrg="currentOrg"></orgInfoDeatil>
      </pane>
      <pane name="2" :label="this.$t('enterprise.deviceAssignment')">
        <deviceAssignmentfrom :currentOrg="currentOrg"></deviceAssignmentfrom>
      </pane>
    </tabs>
  </div>
</template>

<script>
import deviceAssignmentfrom from './deviceAssignment'
import orgInfoDeatil from './orgInfoDeatil'
export default {
  data () {
    return {
      activeName: '1'
    }
  },
  mounted () {},
  props: {
    currentOrg: {
      type: Object,
      default: function () {
        return {}
      }
    },
    parentDept: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    orgInfoDeatil,
    deviceAssignmentfrom
  },
  methods: {}
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/orgStructure/orgInfo.vue